import React from "react";

// Components
import HeaderCard from "./HeaderCard";

type ProjectStatusKey =
  | "savedAsDraft"
  | "bidPipeline"
  | "gonogoApproved"
  | "gonogoRejected"
  | "bidSubmitted"
  | "win"
  | "loss";

type Props = {
  handleBadgeClick: (val: string) => void;
  getCardCount: (key: ProjectStatusKey) => string;
  getCardPrice: (key: ProjectStatusKey) => string;
};

const filterOptions = {
  savedAsDraft: "savedAsDraft",
  bidPipeline: "all",
  gonogoApproved: "approved,bidSubmitted,loss,win",
  gonogoRejected: "rejected",
  bidSubmitted: "bidSubmitted,win,loss",
  win: "win",
  loss: "loss",
};

const BidCards = ({ handleBadgeClick, getCardCount, getCardPrice }: Props) => {
  return (
    <>
      <HeaderCard
        bgColor="#e3f2fd"
        title="Bid Pipeline"
        //onClick={handleBadgeClick}
        filterKey={filterOptions.bidPipeline}
        count={getCardCount("bidPipeline")}
        value={getCardPrice("bidPipeline")}
      />
      <HeaderCard
        bgColor="#e3f2fd"
        title="Go-NoGo Approved"
        //onClick={handleBadgeClick}
        filterKey={filterOptions.gonogoApproved}
        count={getCardCount("gonogoApproved")}
        value={getCardPrice("gonogoApproved")}
      />
      <HeaderCard
        bgColor="#e3f2fd"
        title="Go-NoGo Rejected"
        //onClick={handleBadgeClick}
        filterKey={filterOptions.gonogoRejected}
        count={getCardCount("gonogoRejected")}
        value={getCardPrice("gonogoRejected")}
      />
      <HeaderCard
        bgColor="#e3f2fd"
        title="Bid Submitted"
        //onClick={handleBadgeClick}
        filterKey={filterOptions.bidSubmitted}
        count={getCardCount("bidSubmitted")}
        value={getCardPrice("bidSubmitted")}
      />
      <HeaderCard
        bgColor="#e3f2fd"
        title="Won"
        //onClick={handleBadgeClick}
        filterKey={filterOptions.win}
        count={getCardCount("win")}
        value={getCardPrice("win")}
      />
      <HeaderCard
        bgColor="#e3f2fd"
        title="Lost"
        //onClick={handleBadgeClick}
        filterKey={filterOptions.loss}
        count={getCardCount("loss")}
        value={getCardPrice("loss")}
      />
    </>
  );
};

export default BidCards;
